export interface Video {
  id: number;
  title: string;
  category: string;
  thumbnail: string;
  duration: string;
  views: string;
  rating: number;
  year: number;
  description: string;
  tags: string[];
  featured: boolean;
  hot: boolean;
  updateDate: string;
}

export const videos: Video[] = [
  {
    id: 1,
    title: "流浪地球3",
    category: "dianying",
    thumbnail: "https://readdy.ai/api/search-image?query=Cinematic%20sci-fi%20movie%20poster%20with%20futuristic%20space%20station%20and%20Earth%20in%20background%2C%20dramatic%20lighting%2C%20epic%20scale%2C%20dark%20atmosphere%20with%20warm%20orange%20accents%2C%20movie%20poster%20style%2C%20high%20contrast%2C%20professional%20cinematography%20aesthetic&width=800&height=450&seq=video-thumb-01&orientation=landscape",
    duration: "02:28:15",
    views: "1258万",
    rating: 9.3,
    year: 2026,
    description: "太阳急速老化，持续膨胀。人类面临末日灾难与生命存续的双重挑战。联合政府决定将地球改造成一艘「宇宙飞船」，开启长达2500年的流浪之旅。在危机四伏的宇宙中，人类文明的火种能否延续？",
    tags: ["科幻", "冒险", "灾难", "国产大片"],
    featured: true,
    hot: true,
    updateDate: "2026-07-28",
  },
  {
    id: 2,
    title: "长安十二时辰",
    category: "dianshiju",
    thumbnail: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20Tang%20dynasty%20drama%20scene%20with%20traditional%20architecture%20and%20lanterns%2C%20mysterious%20atmosphere%2C%20warm%20golden%20lighting%2C%20historical%20costume%20drama%20aesthetic%2C%20cinematic%20composition&width=800&height=450&seq=video-thumb-02&orientation=landscape",
    duration: "45集",
    views: "892万",
    rating: 9.1,
    year: 2025,
    description: "天宝三载，上元节前夕，长安城陷入危机。死囚张小敬临危受命，与靖安司司丞李必携手，在十二时辰内拯救长安城。一场惊心动魄的追凶之旅就此展开。",
    tags: ["古装", "悬疑", "历史", "国产剧"],
    featured: true,
    hot: true,
    updateDate: "2026-07-30",
  },
  {
    id: 3,
    title: "乘风破浪的姐姐 第五季",
    category: "zongyi",
    thumbnail: "https://readdy.ai/api/search-image?query=Glossy%20Chinese%20variety%20show%20stage%20with%20colorful%20spotlights%20and%20dynamic%20performance%20energy%2C%20entertainment%20show%20vibe%2C%20bright%20vibrant%20colors%20on%20dark%20stage%2C%20professional%20stage%20lighting&width=800&height=450&seq=video-thumb-03&orientation=landscape",
    duration: "12期",
    views: "2156万",
    rating: 8.8,
    year: 2026,
    description: "30位30+姐姐再次集结，用舞台证明年龄只是数字。全新的赛制，更激烈的比拼，谁能突破自我，成团出道？精彩不容错过！",
    tags: ["真人秀", "音乐", "竞演", "女性"],
    featured: false,
    hot: true,
    updateDate: "2026-08-01",
  },
  {
    id: 4,
    title: "鬼灭之刃 无限城篇",
    category: "dongman",
    thumbnail: "https://readdy.ai/api/search-image?query=Japanese%20anime%20style%20dark%20fantasy%20scene%20with%20samurai%20and%20demons%2C%20dramatic%20action%20pose%2C%20vivid%20colors%20with%20dark%20background%2C%20anime%20movie%20poster%20aesthetic%2C%20dynamic%20composition&width=800&height=450&seq=video-thumb-04&orientation=landscape",
    duration: "01:55:30",
    views: "678万",
    rating: 9.5,
    year: 2026,
    description: "炭治郎一行人终于抵达无限城，与鬼舞辻无惨的最终决战一触即发。柱与上弦之鬼的激烈对决，燃爆全场！",
    tags: ["热血", "战斗", "日漫", "剧场版"],
    featured: true,
    hot: true,
    updateDate: "2026-07-25",
  },
  {
    id: 5,
    title: "地球脉动 第三季",
    category: "jilupian",
    thumbnail: "https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20scene%20with%20wild%20animals%20in%20their%20natural%20habitat%2C%20breathtaking%20landscape%2C%20cinematic%20wildlife%20photography%2C%20golden%20hour%20lighting%2C%20National%20Geographic%20style&width=800&height=450&seq=video-thumb-05&orientation=landscape",
    duration: "8集",
    views: "456万",
    rating: 9.8,
    year: 2025,
    description: "BBC王牌纪录片系列最新力作。从深海到雪山，从荒漠到雨林，用最先进的拍摄技术，记录地球上最震撼的生命故事。",
    tags: ["自然", "动物", "BBC", "4K"],
    featured: false,
    hot: false,
    updateDate: "2026-06-15",
  },
  {
    id: 6,
    title: "NBA总决赛 2026",
    category: "tiyu",
    thumbnail: "https://readdy.ai/api/search-image?query=Professional%20basketball%20game%20intense%20moment%20with%20players%20in%20action%20on%20court%2C%20dramatic%20sports%20photography%2C%20arena%20lights%2C%20dynamic%20movement%2C%20NBA%20finals%20atmosphere&width=800&height=450&seq=video-thumb-06&orientation=landscape",
    duration: "02:45:00",
    views: "3210万",
    rating: 9.6,
    year: 2026,
    description: "2026年NBA总决赛全程回放。巅峰对决，精彩绝杀，每一秒都不容错过。高清画质，专业解说，让你身临其境感受总决赛的激情。",
    tags: ["篮球", "NBA", "总决赛", "体育"],
    featured: false,
    hot: true,
    updateDate: "2026-07-20",
  },
  {
    id: 7,
    title: "满江红2",
    category: "dianying",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20historical%20suspense%20film%20scene%20with%20ancient%20Chinese%20courtyard%20and%20mysterious%20atmosphere%2C%20dark%20cinematic%20lighting%2C%20traditional%20Chinese%20architecture%2C%20tense%20mood&width=800&height=450&seq=video-thumb-07&orientation=landscape",
    duration: "02:35:20",
    views: "1890万",
    rating: 8.9,
    year: 2026,
    description: "南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。一桩离奇命案引发了一场惊心动魄的暗战。真相与谎言交织，忠诚与背叛并存。",
    tags: ["历史", "悬疑", "古装", "国产"],
    featured: true,
    hot: false,
    updateDate: "2026-07-15",
  },
  {
    id: 8,
    title: "狂飙 第二季",
    category: "dianshiju",
    thumbnail: "https://readdy.ai/api/search-image?query=Crime%20thriller%20drama%20scene%20in%20modern%20Chinese%20city%20at%20night%2C%20police%20and%20underworld%20tension%2C%20dark%20moody%20lighting%2C%20suspenseful%20atmosphere%2C%20TV%20drama%20aesthetic&width=800&height=450&seq=video-thumb-08&orientation=landscape",
    duration: "40集",
    views: "3560万",
    rating: 9.4,
    year: 2026,
    description: "扫黑除恶专项斗争持续深入，新的案件浮出水面。安欣带领专案组再次出击，一场正义与邪恶的较量在江城展开。",
    tags: ["刑侦", "扫黑", "剧情", "国产"],
    featured: false,
    hot: true,
    updateDate: "2026-08-01",
  },
  {
    id: 9,
    title: "海贼王 最终章",
    category: "dongman",
    thumbnail: "https://readdy.ai/api/search-image?query=Epic%20pirate%20adventure%20anime%20scene%20with%20pirate%20ship%20on%20vast%20ocean%2C%20dramatic%20sunset%20sky%2C%20adventure%20spirit%2C%20anime%20style%20with%20vibrant%20colors%2C%20cinematic%20composition&width=800&height=450&seq=video-thumb-09&orientation=landscape",
    duration: "连载中",
    views: "5670万",
    rating: 9.7,
    year: 2026,
    description: "路飞和他的伙伴们终于抵达拉夫德鲁，ONE PIECE的秘密即将揭晓。二十多年的冒险之旅，迎来最激动人心的终章！",
    tags: ["冒险", "热血", "日漫", "经典"],
    featured: true,
    hot: true,
    updateDate: "2026-07-31",
  },
  {
    id: 10,
    title: "舌尖上的中国 第五季",
    category: "jilupian",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20food%20documentary%20scene%20with%20traditional%20cooking%20and%20delicious%20dishes%2C%20warm%20kitchen%20lighting%2C%20steaming%20food%2C%20authentic%20Chinese%20culinary%20culture%2C%20appetizing%20presentation&width=800&height=450&seq=video-thumb-10&orientation=landscape",
    duration: "10集",
    views: "2340万",
    rating: 9.2,
    year: 2026,
    description: "走遍中国大地，探寻最地道的美食故事。从街头小吃到宫廷御膳，每一道美食背后都有一个动人的故事。",
    tags: ["美食", "文化", "纪录片", "中国"],
    featured: false,
    hot: false,
    updateDate: "2026-06-20",
  },
  {
    id: 11,
    title: "英雄联盟S16全球总决赛",
    category: "tiyu",
    thumbnail: "https://readdy.ai/api/search-image?query=Esports%20arena%20with%20massive%20crowd%20and%20giant%20screens%20showing%20game%20action%2C%20colorful%20stage%20lighting%2C%20competitive%20gaming%20atmosphere%2C%20grand%20scale%20event&width=800&height=450&seq=video-thumb-11&orientation=landscape",
    duration: "05:30:00",
    views: "8900万",
    rating: 9.8,
    year: 2026,
    description: "全球最强战队齐聚，争夺召唤师杯。巅峰操作，惊险翻盘，每一场比赛都让人热血沸腾。电竞爱好者的视觉盛宴！",
    tags: ["电竞", "LOL", "总决赛", "游戏"],
    featured: false,
    hot: true,
    updateDate: "2026-07-29",
  },
  {
    id: 12,
    title: "喜剧之王3",
    category: "dianying",
    thumbnail: "https://readdy.ai/api/search-image?query=Chinese%20comedy%20film%20scene%20with%20bright%20and%20cheerful%20atmosphere%2C%20warm%20lighting%2C%20actors%20in%20funny%20situation%2C%20entertaining%20movie%20poster%20style%2C%20cinematic%20but%20lighthearted&width=800&height=450&seq=video-thumb-12&orientation=landscape",
    duration: "02:05:40",
    views: "1560万",
    rating: 8.7,
    year: 2026,
    description: "一个默默无闻的龙套演员，在追梦路上经历了一系列令人啼笑皆非的故事。笑中带泪，温暖人心。",
    tags: ["喜剧", "励志", "温情", "国产"],
    featured: false,
    hot: false,
    updateDate: "2026-07-10",
  },
];

export function getVideosByCategory(slug: string): Video[] {
  return videos.filter((v) => v.category === slug);
}

export function getVideoById(id: number): Video | undefined {
  return videos.find((v) => v.id === id);
}

export function getFeaturedVideos(): Video[] {
  return videos.filter((v) => v.featured);
}

export function getHotVideos(): Video[] {
  return videos.filter((v) => v.hot);
}

export function getLatestVideos(limit: number = 8): Video[] {
  return [...videos].sort((a, b) => b.updateDate.localeCompare(a.updateDate)).slice(0, limit);
}